import React, { useEffect, useState } from 'react'
import StarEmptyIcon from './../../img/star-empty.svg'
import StarHalfIcon from './../../img/star-half.svg'
import StarFullIcon from './../../img/star-full.svg'
import CircleIcon from './../../img/circle.svg'
import { StyledContainer } from './Rating.styled'
import clsx from 'clsx'

type propType = {
  selectable?: boolean
  onSelect?: (num: number) => void
  value?: number
  type?: 'circle' | 'star'
  showEmpty?: boolean
  className?: string
}

const Rating = ({
  selectable = false,
  onSelect,
  value = -1,
  type = 'circle',
  showEmpty = true,
  className = ''
}: propType) => {
  const [hoverPointer, setHoverPointer] = useState(-1)
  const [stars, setStars] = useState(-1)
  const redColor = '#cf0101'

  const handleEnter = (_e: React.MouseEvent<Element, MouseEvent>, idx: number) => {
    setHoverPointer(idx)
    // $(e.currentTarget).one('mouseleave', handleLeave)
  }

  const handleLeave = () => {
    setHoverPointer(-1)
  }

  const handleClick = (idx: number) => {
    setStars(idx)

    if (onSelect) {
      onSelect(idx + 1)
    }
  }

  useEffect(() => {
    if (typeof value === 'number' && value > -1) {
      setStars(value - 1)
    }
  }, [value])

  return (
    <StyledContainer
      className={clsx(
        {
          editable: selectable
        },
        className
      )}
    >
      {new Array(5).fill('').map((v, idx) => {
        const attrs = {
          key: idx,
          width: 20,
          height: 20,
          viewBox: type === 'circle' ? '0 0 512 512' : '0 0 67 63'
        }

        if (selectable) {
          const attrsEditable = {
            onMouseEnter: (e: React.MouseEvent<Element, MouseEvent>) => {
              handleEnter(e, idx)
            },
            onMouseLeave: handleLeave,
            onClick: () => {
              handleClick(idx)
            }
          }

          if (idx <= hoverPointer || idx <= stars) {
            if (type === 'circle') {
              return <CircleIcon fill={redColor} {...attrs} {...attrsEditable} />
            } else {
              return <StarFullIcon fill={redColor} {...attrs} {...attrsEditable} />
            }
          }

          if (type === 'circle') {
            return <CircleIcon {...attrs} {...attrsEditable} />
          } else {
            return <StarEmptyIcon {...attrs} {...attrsEditable} />
          }
        } else {
          if (idx <= stars) {
            if (type === 'circle') {
              return <CircleIcon fill={redColor} {...attrs} />
            } else {
              return <StarFullIcon fill={redColor} {...attrs} />
            }
          } else if (idx > stars && idx < stars + 1) {
            return <StarHalfIcon fill={redColor} {...attrs} />
          }

          if (showEmpty) {
            if (type === 'circle') {
              return <CircleIcon {...attrs} />
            } else {
              return <StarEmptyIcon {...attrs} />
            }
          }
        }
      })}
    </StyledContainer>
  )
}

export default Rating
